module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Beckie-Jo currently lives in Lancashire where she enjoys teaching, singing and coming up with ‘genius plans’. The children that she teaches will tell you that she’s funny but fair, her family will tell you that she’s never frightened to tell you what she’s thinking and her friends will tell you that she always has a good story to tell. Her smile is infectious, and her love of mischief means life around her is never dull. She thrives on people telling her, ‘you can’t possibly do that, to ensure that she most definitely can!’ She identifies tomato sauce as one of the five main food groups, her piano as her desert island disk and her life as a series of adventures to be lived whether laughing or crying.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0